"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const styles_1 = require("./styles");

const MenuItem = props => {
  const {
    children,
    text,
    icon,
    stylesOverride,
    size = 'm',
    onClick
  } = props;
  return (0, jsx_runtime_1.jsxs)(styles_1.StyledListItem, Object.assign({
    size: size,
    onClick: onClick,
    stylesOverride: stylesOverride
  }, {
    children: [icon && (0, jsx_runtime_1.jsx)(styles_1.ListItemIcon, {
      children: icon
    }, void 0), children, text && (0, jsx_runtime_1.jsx)(styles_1.ListItemText, {
      children: text
    }, void 0)]
  }), void 0);
};

exports.default = MenuItem;